import React from 'react'
import { Link } from 'react-router'

import api from '../../api'

export default class ResourceDisplay extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      resource: {}
    }
  }

  componentWillMount () {
    const body = { with_deleted: true }
    for (const prop in this.props.filters) {
      body[`filters[${prop}]`] = this.props.filters[prop]
    }

    api.get(this.props.path, { body })
      .then(res => res.json())
      .then(resources => {
        this.setState({
          resource: resources[0],
          isLoaded: true
        })
      })
  }

  render () {
    const { resource, isLoaded } = this.state
    const { link, display } = this.props

    if (!isLoaded) {
      return <div>Loading...</div>
    }

    const value = typeof display === 'function'
      ? display(resource)
      : resource[display]

    const linkPath = link && link(resource)

    const label = linkPath
      ? <Link to={linkPath}>{value}</Link>
      : value

    const status = resource.deleted_at
      ? <em> (deleted)</em>
      : null

    return <span>{label}{status}</span>
  }
}

// @ts-ignore
ResourceDisplay.propTypes = {
  path: React.PropTypes.string.isRequired,
  filters: React.PropTypes.object.isRequired,
  display: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.func
  ]).isRequired,
  link: React.PropTypes.func
}
